import deepMerge from 'shadow-fns/src/deepMerge'
import isBoolean from './isBoolean'
import isObject from './isObject'
import isFunction from './isFunction'

const mergeOptions = (value, defaults) => {
  const val = isBoolean(value) || isObject(value) ? null : value
  const def = isFunction(defaults) ? defaults(val) : defaults

  if (isObject(value))
    return deepMerge(def, value)

  if (value == false)
    return {}

  return def
}

export default mergeOptions
